"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.G = exports.Guard = void 0;
const value_1 = require("./value");
const error_1 = require("./error");
function not(guard) {
    return function (value) {
        return !guard(value);
    };
}
/**
 * Common type guards
 */
var Guard;
(function (Guard) {
    /**
     * String guards
     */
    let String;
    (function (String) {
        String.isEmpty = (value) => value === "";
        String.isNotEmpty = not(String.isEmpty);
        String.isNullishOrEmpty = (value) => String.isEmpty(value) || Guard.isNullish(value);
        String.isNotNullishOrEmpty = not(String.isNullishOrEmpty);
        String.equals = (expected) => (value) => value === expected;
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        String.notEquals = (notExpected) => not(String.equals(notExpected));
    })(String = Guard.String || (Guard.String = {}));
    Guard.Str = String;
    /**
     * Number guards
     */
    let Number;
    (function (Number) {
        Number.equals = (expected) => (value) => value === expected;
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        Number.notEquals = (notExpected) => not(Number.equals(notExpected));
    })(Number = Guard.Number || (Guard.Number = {}));
    Guard.Num = Number;
    /**
     * Boolean guards
     */
    let Boolean;
    (function (Boolean) {
        Boolean.equals = (expected) => (value) => value === expected;
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        Boolean.notEquals = (notExpected) => not(Boolean.equals(notExpected));
        Boolean.isTrue = Boolean.equals(true);
        Boolean.isFalse = Boolean.equals(false);
    })(Boolean = Guard.Boolean || (Guard.Boolean = {}));
    Guard.Bool = Boolean;
    /**
     * Enum guards
     */
    let Enum;
    (function (Enum) {
        Enum.isEnumMember = (enumType) => (value) => Object.values(enumType).includes(value);
        Enum.isNotEnumMember = (enumType) => (value) => !Enum.isEnumMember(enumType)(value);
    })(Enum = Guard.Enum || (Guard.Enum = {}));
    /**
     * Array guards
     */
    let Array;
    (function (Array) {
        Array.isOfLength = (length) => (arr) => arr.length == length;
        // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
        Array.isNotOfLength = (length) => not(Array.isOfLength(length));
    })(Array = Guard.Array || (Guard.Array = {}));
    Guard.Arr = Array;
    Guard.isDerivedConstructor = (ctor) => (value) => typeof value === "function" && value.prototype instanceof ctor;
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    Guard.isNotDerivedConstructor = (ctor) => not(Guard.isDerivedConstructor(ctor));
    Guard.isInstanceOf = (expected) => (value) => value instanceof expected;
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    Guard.isNotInstanceOf = (notExpected) => not(Guard.isInstanceOf(notExpected));
    Guard.isNullish = (value) => value === null || value === undefined;
    Guard.isNotNullish = not(Guard.isNullish);
    Guard.isNull = (value) => value === null;
    Guard.isNotNull = not(Guard.isNull);
    Guard.isUndefined = (value) => value === undefined;
    Guard.isNotUndefined = not(Guard.isUndefined);
    Guard.isTruthy = (value) => !!value;
    Guard.isFalsy = (value) => !value;
    function singleBy(guard) {
        return function (...args) {
            const last = new value_1.Value();
            for (const arg of args) {
                if (guard(arg)) {
                    if (last.hasValue)
                        throw new Error("Expected a single element matching the specified predicate, but got at least 2.");
                    else
                        last.value = arg;
                }
            }
            return last.hasValue ? last.value : undefined;
        };
    }
    Guard.singleBy = singleBy;
    function singleByOrThrow(guard) {
        return function (...args) {
            const last = new value_1.Value();
            for (const arg of args) {
                if (guard(arg)) {
                    if (last.hasValue)
                        throw new Error("Expected a single element matching the specified predicate, but got at least 2.");
                    else
                        last.value = arg;
                }
            }
            return last.hasValue ? last.value : error_1.raise(new Error("Expected a single element matching the specified predicate, but got none."));
        };
    }
    Guard.singleByOrThrow = singleByOrThrow;
    function firstBy(guard) {
        return function (...args) {
            for (const arg of args) {
                if (guard(arg))
                    return arg;
            }
            return undefined;
        };
    }
    Guard.firstBy = firstBy;
    function firstByOrThrow(guard) {
        return function (...args) {
            for (const arg of args) {
                if (guard(arg))
                    return arg;
            }
            throw new Error("Expected at least one element to match the specified guard, but got none.");
        };
    }
    Guard.firstByOrThrow = firstByOrThrow;
    function lastBy(guard) {
        return function (...args) {
            for (const arg of args.reverse()) {
                if (guard(arg))
                    return arg;
            }
            return undefined;
        };
    }
    Guard.lastBy = lastBy;
    function lastByOrThrow(guard) {
        return function (...args) {
            for (const arg of args.reverse()) {
                if (guard(arg))
                    return arg;
            }
            throw new Error("Expected at least one element to match the specified guard, but got none.");
        };
    }
    Guard.lastByOrThrow = lastByOrThrow;
})(Guard = exports.Guard || (exports.Guard = {}));
exports.G = Guard;
//# sourceMappingURL=guard.js.map